<template>
    <div>
        <async-linear-progress v-if="loader" :task="task" />
        <slot v-if="show" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncLinearProgress from '../loading/AsyncLinearProgress.vue';

interface Data {
  show: boolean,
}

export default defineComponent({
  components: { AsyncLinearProgress },
  props: {
    task: Promise,
    loader: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      show: false,
    };
  },
  watch: {
    task: {
      handler(task: Promise<any>|null) {
        this.show = false;
        if (!task) return;
        task.finally(() => {
          this.show = true;
        });
      },
      immediate: true,
    },
  },
});
</script>
